<gh-dropdown
  *ngIf="menuItems?.length > 0"
  [menuItems]="menuItems"
  [disabled]="disabled"
  [a11yLabel]="'comment_options' | localize"
  dropdownMenuClass="comment-options"
  iconName="ellipsis"></gh-dropdown>
